/**
 * Main questions file - combines all question sections
 * This file imports questions from organized category files
 */

import { demographicsQuestions } from './demographics';
import { beerTypesQuestions } from './beerTypes';
import { beerConsumptionQuestions } from './beerConsumption';
import { beerPreferencesQuestions } from './beerPreferences';
import { craftBeerQuestions } from './craftBeer';
import { beerEventsQuestions } from './beerEvents';
import { beerTravelQuestions } from './beerTravel';
import { beerContentQuestions } from './beerContent';
import { beerBehaviorQuestions } from './beerBehavior';
import { nonAlcoholBeerQuestions } from './nonAlcoholBeer';
import { drinkingHabitQuestions } from './drinkingHabit';
import { userInfoQuestions } from './userInfo';

export const QUESTIONS = [
  ...demographicsQuestions,
  ...beerTypesQuestions,
  ...beerConsumptionQuestions,
  ...beerPreferencesQuestions,
  ...craftBeerQuestions,
  ...beerEventsQuestions,
  ...beerTravelQuestions,
  ...beerContentQuestions,
  ...beerBehaviorQuestions,
  ...nonAlcoholBeerQuestions,
  ...drinkingHabitQuestions,
  ...userInfoQuestions,
];

// Re-export validations for convenience
export { validations } from './validations';
